const REGEXP = {
  fullNameRegex: /^(?=.*[a-zA-Z].*)([-a-zA-Z0-9\s_@#$%^&()!?;:,.^*]+)$/,
  usernameRegex: /^[a-zA-Z ]+$/, // allows underscore as well
  editUsernameRegex: /^[a-zA-Z0-9_ ]+$/,
  referenceIdRegex: /^[A-Za-z0-9-]+$/,
  bankReferenceNumber: /^[a-zA-Z0-9]*$/,
  settlementAccountNameRegex: /^[a-zA-Z0-9_. -]+$/,
  amountRegex: /^\d*(\.\d+)?$/,
  panRegex:
    /^(?:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}|[A-Za-z]{3}[Pp][A-Za-z][0-9]{4}[A-Za-z])$/,
  phoneNumberRegex: /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/,
  mobileRegex: /^[9876]\d{9}$/,
  dateRegex: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/,
  emailRegex:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  urlRegexCallback:
    /^((https?|ftp|smtp):\/\/)?(www\.)?[a-z0-9|_-]+(\.[a-z]{2,}){1,10}(#?\/?[a-zA-Z0-9#|_-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  urlRegex:
    /^((https?|ftp|smtp):\/\/)?(www\.)?[a-zA-Z0-9._-]+(\.[a-zA-Z0-9-]{2,}){1,}(\/[a-zA-Z0-9#._-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  ifscRegex: /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/,
  accountNumberRegex: /^\d{9,18}$/,
  laAccountRegex: /^[a-zA-Z\d]{9,36}$/,
  alphanumericRegex: /^[a-zA-Z0-9]+$/,
  authCodeRegex: /^[0-9]{6}$/,
  vaRegex: /^[0-9]{9,18}$/,
  clientIDRegex: /^[A-Za-z0-9_]+$/, // wont allow empty space for clientID
  addressRegex: /^[\w\s\.,#\-\/]+$/u,
  gstRegex:
    /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
  cityRegex: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  pincodeRegex: /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/,
  stateRegex: /^[a-zA-Z]+(?: [a-zA-Z]+)?$/,
  districtRegex: /^[a-zA-Z]+(?: [a-zA-Z]+)?$/,
  countryRegex: /^[a-zA-Z]+(?: [a-zA-Z]+)?$/,
  numberRegex: /^\d+$/,
  categoryCodeRegex: /^\d{3,4}$/,
  categoryRegex: /^[a-zA-Z0-9\s&,()/–-]+$/u,
  merchantCategoryCode: /^\d{3,4}$/,
  UPIRegex: /^[a-zA-Z0-9.-]{2,256}@[a-zA-Z][a-zA-Z]{2,64}$/,
  consumerUrnRegex: /^[0-9A-F]{32}$/,
  nameFieldRegex: /^[a-zA-Z-' ]+$/,
  passwordRegex:
    /^(?=.*\d)(?=.*[A-Z])(?=.*[~!@#$%^&*()_+])[A-Za-z\d~!@#$%^&*()_+]{8,20}$/,
  cinLlpinRegex:
    /^(?:[a-zA-Z0-9]{3}-[a-zA-Z0-9]{4}|[L|U][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6})$/,
  vpaFieldRegex: /^[a-zA-Z0-9]*$/,
  ipAddressRegex:
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  dataTableDateTimeRegex: /^(\d{2})\/(\d{2})\/(\d{4})/,
};

const numberRegexValidate = (number) => {
  if (number.match(REGEXP.numberRegex)) {
    return true;
  }
  return false;
};

const merchantCategoryCodeRegexValidate = (number) => {
  if (number.match(REGEXP.categoryCodeRegex)) {
    return true;
  }
  return false;
};

const merchantCategoryRegexValidate = (number) => {
  if (number.match(REGEXP.categoryRegex)) {
    return true;
  }
  return false;
};

const countryRegexValidate = (country) => {
  if (country.match(REGEXP.countryRegex)) {
    return true;
  }
  return false;
};

const districtRegexValidate = (district) => {
  if (district.match(REGEXP.districtRegex)) {
    return true;
  }
  return false;
};

const stateRegexValidate = (state) => {
  if (state.match(REGEXP.stateRegex)) {
    return true;
  }
  return false;
};

const pincodeRegexValidate = (pincode) => {
  if (pincode.match(REGEXP.pincodeRegex)) {
    return true;
  }
  return false;
};

const cityRegexValidate = (cityName) => {
  if (cityName.match(REGEXP.cityRegex)) {
    return true;
  }
  return false;
};

const gstRegexValidate = (gstNumber) => {
  if (gstNumber.match(REGEXP.gstRegex)) {
    return true;
  }
  return false;
};

const addressRegexValidate = (address) => {
  if (address.match(REGEXP.addressRegex)) {
    return true;
  }
  return false;
};

const mobileRegexValidate = (phoneNumber) => {
  if (phoneNumber.match(REGEXP.phoneNumberRegex)) {
    return true;
  }
  return false;
};

const clientIDRegexValidate = (clientID) => {
  if (clientID.match(REGEXP.clientIDRegex)) {
    return false;
  }
  return true;
};

const emailRegexValidate = (email) => {
  if (email.match(REGEXP.emailRegex)) {
    return true;
  }
  return false;
};

const urlRegexValidate = (url) => {
  if (url.match(REGEXP.urlRegex)) {
    return true;
  }
  return false;
};

const ifscValidation = (value) => {
  if (value.match(REGEXP.ifscRegex)) {
    return true;
  }
  return false;
};

const accountNumberValidation = (value) => {
  if (value.match(REGEXP.accountNumberRegex)) {
    return true;
  }
  return false;
};

const alphanumericRegexValidate = (value) => {
  if (value.match(REGEXP.alphanumericRegex)) {
    return true;
  }
  return false;
};

export {
  mobileRegexValidate,
  emailRegexValidate,
  urlRegexValidate,
  ifscValidation,
  accountNumberValidation,
  alphanumericRegexValidate,
  REGEXP,
  clientIDRegexValidate,
  addressRegexValidate,
  gstRegexValidate,
  cityRegexValidate,
  numberRegexValidate,
  countryRegexValidate,
  stateRegexValidate,
  pincodeRegexValidate,
  districtRegexValidate,
  merchantCategoryCodeRegexValidate,
  merchantCategoryRegexValidate,
};
